export interface VideoItem {
  id: string;
  title: string;
  category: string;
  categorySlug: string;
  thumbnail: string;
  duration: string;
  views: string;
  description: string;
  tags: string[];
  date: string;
  author: string;
  featured: boolean;
  rating: string;
}

export interface CategoryItem {
  name: string;
  slug: string;
  icon: string;
  description: string;
  count: number;
}

export const categories: CategoryItem[] = [
  { name: '动漫', slug: 'dongman', icon: 'ri-movie-2-line', description: '热血、治愈、冒险，各类动漫佳作汇聚一堂', count: 1256 },
  { name: '短视频', slug: 'duanshipin', icon: 'ri-vidicon-line', description: '精彩短视频，随时随地轻松观看', count: 3421 },
  { name: '搞笑视频', slug: 'gaoxiao', icon: 'ri-emotion-laugh-line', description: '搞笑段子、趣味视频，让你笑到停不下来', count: 2189 },
  { name: '特色节目', slug: 'tesejiemu', icon: 'ri-tv-2-line', description: '妖精视频、桃花视频等特色频道精选', count: 987 },
  { name: '苹果视频', slug: 'pingguo', icon: 'ri-apple-line', description: '苹果视频精选内容，高清画质畅享', count: 638 },
  { name: '榴莲视频', slug: 'liulian', icon: 'ri-fire-line', description: '榴莲视频热门推荐，精彩不断', count: 542 },
];

export const videos: VideoItem[] = [
  {
    id: 'v001',
    title: '【热血动漫】进击的巨人最终季：自由之翼的抉择',
    category: '动漫',
    categorySlug: 'dongman',
    thumbnail: 'https://readdy.ai/api/search-image?query=Epic%20anime%20scene%20with%20giant%20titan%20and%20soldiers%20in%20dramatic%20battle%2C%20cinematic%20lighting%20with%20warm%20golden%20and%20crimson%20tones%2C%20detailed%20illustration%20style%2C%20epic%20composition&width=640&height=360&seq=dongman-hero-01&orientation=landscape',
    duration: '24:18',
    views: '128.5万',
    description: '艾伦与调查兵团面临最终抉择，自由之翼将飞向何方？本季带来震撼视觉与深刻思考，不容错过的史诗级动漫大作。',
    tags: ['热血', '战斗', '剧情'],
    date: '2026-07-28',
    author: '番茄动漫',
    featured: true,
    rating: '9.7',
  },
  {
    id: 'v002',
    title: '【治愈系】夏目友人帐第七季：温暖人心的妖怪故事',
    category: '动漫',
    categorySlug: 'dongman',
    thumbnail: 'https://readdy.ai/api/search-image?query=Soft%20peaceful%20anime%20scene%20with%20boy%20and%20spirit%20creature%20in%20lush%20green%20forest%2C%20gentle%20sunlight%20filtering%20through%20trees%2C%20watercolor%20illustration%20style%2C%20warm%20and%20healing%20atmosphere&width=640&height=360&seq=dongman-warm-02&orientation=landscape',
    duration: '23:45',
    views: '89.2万',
    description: '夏目贵志继续与妖怪们的邂逅，每一集都是一个温暖人心的故事，治愈你疲惫的心灵。',
    tags: ['治愈', '奇幻', '日常'],
    date: '2026-07-25',
    author: '番茄动漫',
    featured: true,
    rating: '9.5',
  },
  {
    id: 'v003',
    title: '【搞笑合集】笑到肚子疼的沙雕动物集锦 2026',
    category: '搞笑视频',
    categorySlug: 'gaoxiao',
    thumbnail: 'https://readdy.ai/api/search-image?query=Funny%20compilation%20of%20adorable%20dogs%20and%20cats%20making%20silly%20faces%20and%20doing%20clumsy%20things%2C%20bright%20cheerful%20lighting%2C%20playful%20colorful%20background%2C%20entertaining%20pet%20photography&width=640&height=360&seq=funny-animals-03&orientation=landscape',
    duration: '08:32',
    views: '356.7万',
    description: '全网最搞笑的动物合集来啦！狗狗猫猫的沙雕瞬间，保证让你笑得合不拢嘴，减压神器！',
    tags: ['搞笑', '动物', '合集'],
    date: '2026-08-01',
    author: '番茄搞笑',
    featured: true,
    rating: '9.3',
  },
  {
    id: 'v004',
    title: '【创意短视频】3分钟学会超酷炫的转场技巧',
    category: '短视频',
    categorySlug: 'duanshipin',
    thumbnail: 'https://readdy.ai/api/search-image?query=Creative%20video%20editing%20transition%20techniques%20demonstration%2C%20modern%20smartphone%20filming%20setup%20on%20desk%2C%20clean%20minimalist%20workspace%20with%20warm%20ambient%20lighting%2C%20tutorial%20style%20photography&width=640&height=360&seq=transition-tricks-04&orientation=landscape',
    duration: '03:15',
    views: '215.3万',
    description: '短视频创作者必备技能！3分钟学会专业级转场，让你的视频质感瞬间提升，简单易学。',
    tags: ['教程', '创意', '拍摄'],
    date: '2026-07-30',
    author: '番茄创意',
    featured: false,
    rating: '9.1',
  },
  {
    id: 'v005',
    title: '【妖精视频精选】奇幻森林之旅：精灵与魔法',
    category: '特色节目',
    categorySlug: 'tesejiemu',
    thumbnail: 'https://readdy.ai/api/search-image?query=Enchanted%20magical%20forest%20with%20glowing%20fairy%20lights%2C%20mystical%20atmosphere%20with%20soft%20ethereal%20glow%2C%20sparkling%20particles%20in%20air%2C%20fantasy%20art%20style%2C%20dreamy%20and%20magical%20composition&width=640&height=360&seq=fairy-forest-05&orientation=landscape',
    duration: '15:42',
    views: '76.8万',
    description: '妖精视频独家呈现奇幻森林主题节目，带你走进充满魔法与精灵的神秘世界，视觉盛宴。',
    tags: ['奇幻', '妖精', '魔法'],
    date: '2026-07-26',
    author: '妖精视频',
    featured: true,
    rating: '9.4',
  },
  {
    id: 'v006',
    title: '【桃花视频】春日限定：桃花盛开的地方',
    category: '特色节目',
    categorySlug: 'tesejiemu',
    thumbnail: 'https://readdy.ai/api/search-image?query=Beautiful%20peach%20blossom%20orchard%20in%20full%20spring%20bloom%20with%20pink%20petals%20falling%2C%20warm%20golden%20sunlight%2C%20romantic%20atmosphere%2C%20traditional%20Chinese%20garden%20setting%2C%20dreamy%20pastel%20color%20palette&width=640&height=360&seq=peach-blossom-06&orientation=landscape',
    duration: '12:08',
    views: '65.4万',
    description: '桃花视频春日特别节目，记录春天最美的桃花盛景，感受大自然的浪漫与生机。',
    tags: ['桃花', '自然', '春天'],
    date: '2026-07-22',
    author: '桃花视频',
    featured: false,
    rating: '9.2',
  },
  {
    id: 'v007',
    title: '【搞笑短剧】办公室里的那些奇葩同事',
    category: '搞笑视频',
    categorySlug: 'gaoxiao',
    thumbnail: 'https://readdy.ai/api/search-image?query=Funny%20office%20comedy%20scene%20with%20coworkers%20doing%20hilarious%20pranks%20and%20silly%20expressions%2C%20modern%20office%20interior%2C%20bright%20natural%20lighting%2C%20entertaining%20workplace%20photography&width=640&height=360&seq=office-comedy-07&orientation=landscape',
    duration: '06:55',
    views: '189.2万',
    description: '办公室里总有那么几个让人哭笑不得的同事，看看有没有你的影子？真实还原职场百态。',
    tags: ['搞笑', '职场', '短剧'],
    date: '2026-08-01',
    author: '番茄搞笑',
    featured: false,
    rating: '9.0',
  },
  {
    id: 'v008',
    title: '【动漫推荐】2026年必看的十部新番动漫',
    category: '动漫',
    categorySlug: 'dongman',
    thumbnail: 'https://readdy.ai/api/search-image?query=Colorful%20anime%20collage%20featuring%20multiple%20popular%20anime%20characters%20in%20dynamic%20poses%2C%20vibrant%20colors%20and%20dramatic%20lighting%20effects%2C%20modern%20anime%20illustration%20style%2C%20eye-catching%20composition&width=640&height=360&seq=anime-collage-08&orientation=landscape',
    duration: '18:20',
    views: '201.6万',
    description: '盘点2026年最值得期待的十部新番动漫，从热血战斗到治愈日常，总有一部适合你！',
    tags: ['推荐', '新番', '盘点'],
    date: '2026-07-29',
    author: '番茄动漫',
    featured: true,
    rating: '9.6',
  },
  {
    id: 'v009',
    title: '【生活技巧】10个让人相见恨晚的厨房妙招',
    category: '短视频',
    categorySlug: 'duanshipin',
    thumbnail: 'https://readdy.ai/api/search-image?query=Modern%20clean%20kitchen%20with%20various%20cooking%20utensils%20and%20fresh%20ingredients%20organized%20neatly%2C%20warm%20natural%20lighting%20from%20window%2C%20lifestyle%20photography%20style%2C%20bright%20and%20inviting%20atmosphere&width=640&height=360&seq=kitchen-hacks-09&orientation=landscape',
    duration: '04:28',
    views: '312.4万',
    description: '超实用的厨房小妙招，学会这些技巧让你秒变厨房达人，做饭省时又省力！',
    tags: ['生活', '技巧', '实用'],
    date: '2026-07-31',
    author: '番茄生活',
    featured: false,
    rating: '9.4',
  },
  {
    id: 'v010',
    title: '【榴莲视频】极限运动：都市跑酷的惊险瞬间',
    category: '特色节目',
    categorySlug: 'tesejiemu',
    thumbnail: 'https://readdy.ai/api/search-image?query=Thrilling%20urban%20parkour%20athlete%20jumping%20between%20modern%20city%20buildings%20at%20sunset%2C%20dramatic%20golden%20hour%20lighting%2C%20dynamic%20action%20photography%2C%20adrenaline-filled%20composition&width=640&height=360&seq=parkour-city-10&orientation=landscape',
    duration: '11:30',
    views: '98.7万',
    description: '榴莲视频带你领略都市跑酷的魅力，极限运动高手在城市间穿梭跳跃，惊险刺激！',
    tags: ['极限', '跑酷', '运动'],
    date: '2026-07-24',
    author: '榴莲视频',
    featured: false,
    rating: '9.1',
  },
  {
    id: 'v011',
    title: '【苹果视频】科技前沿：AI改变生活的10种方式',
    category: '特色节目',
    categorySlug: 'tesejiemu',
    thumbnail: 'https://readdy.ai/api/search-image?query=Futuristic%20artificial%20intelligence%20concept%20with%20holographic%20displays%20and%20digital%20interfaces%2C%20clean%20minimalist%20tech%20aesthetic%2C%20soft%20blue-white%20gradient%20background%2C%20modern%20technology%20illustration&width=640&height=360&seq=ai-tech-11&orientation=landscape',
    duration: '14:55',
    views: '167.3万',
    description: '苹果视频科技频道带你了解人工智能如何改变我们的日常生活，前沿科技一网打尽。',
    tags: ['科技', 'AI', '未来'],
    date: '2026-07-27',
    author: '苹果视频',
    featured: true,
    rating: '9.3',
  },
  {
    id: 'v012',
    title: '【搞笑挑战】蒙眼画画大挑战，结果太意外了',
    category: '搞笑视频',
    categorySlug: 'gaoxiao',
    thumbnail: 'https://readdy.ai/api/search-image?query=Funny%20blindfolded%20drawing%20challenge%20with%20colorful%20messy%20artwork%20results%2C%20people%20laughing%20and%20having%20fun%2C%20bright%20playful%20studio%20setting%2C%20entertaining%20group%20activity%20photography&width=640&height=360&seq=drawing-challenge-12&orientation=landscape',
    duration: '07:18',
    views: '234.5万',
    description: '蒙眼画画挑战赛，小伙伴们的画作简直让人笑翻！你猜谁画得最离谱？',
    tags: ['挑战', '搞笑', '互动'],
    date: '2026-07-31',
    author: '番茄搞笑',
    featured: false,
    rating: '8.9',
  },
];

export const featuredVideos = videos.filter(v => v.featured);
export const popularVideos = [...videos].sort(() => Math.random() - 0.5);
export const newVideos = [...videos].sort((a, b) => new Date(b.date).getTime() - new Date(a.date).getTime());

export const statsData = {
  totalVideos: '8,500+',
  dailyViews: '1200万+',
  totalUsers: '360万+',
  categoriesCount: '15+',
};

export const aboutContent = {
  brandIntro: '番茄视频成立于2024年，是一个综合性的视频内容聚合平台。我们致力于为用户提供高品质、多元化的视频内容，聚合了妖精视频、桃花视频、苹果视频、榴莲视频等众多特色频道，涵盖动漫、短视频、搞笑视频、趣味节目等多种类型。',
  mission: '让每个人都能轻松找到并享受自己喜欢的视频内容，打造一个开放、优质的视频内容生态。',
  reputation: [
    { title: '内容质量', description: '严格筛选优质内容，确保每一部视频都经过精心挑选，为用户提供最佳的观看体验。', icon: 'ri-star-line' },
    { title: '播放体验', description: '采用先进的视频传输技术，高清不缓冲，让用户享受流畅的观看体验。', icon: 'ri-speed-up-line' },
    { title: '内容丰富', description: '聚合多个特色频道，涵盖动漫、搞笑、短视频等多种类型，满足不同用户的观看需求。', icon: 'ri-stack-line' },
    { title: '用户口碑', description: '累计服务超过360万用户，好评率高达98.5%，是用户信赖的视频平台。', icon: 'ri-heart-line' },
  ],
  contact: {
    email: 'service@fanqieshipin.com',
    phone: '400-888-6666',
    address: '北京市朝阳区番茄路88号番茄大厦',
    wechat: 'fanqieshipin',
  },
};